import useApiMutation from '@src/hooks/useApiMutation';
import { ControlModeTemplate } from '@src/types/ControlModes';

export default (id?: string) => {
  const cmtPath = `/control-mode-templates${id ? `/${id}` : ''}`;
  const createControlModeTemplate = useApiMutation<
    Omit<ControlModeTemplate, 'id'>,
    ControlModeTemplate
  >({
    apiPath: cmtPath,
    method: 'POST',
    useV2API: true,
  });

  const updateControlModeTemplate = useApiMutation<
    Omit<ControlModeTemplate, 'id'>,
    ControlModeTemplate
  >({
    apiPath: cmtPath,
    method: 'PATCH',
    useV2API: true,
  });

  const deleteControlModeTemplate = useApiMutation({
    apiPath: cmtPath,
    method: 'DELETE',
    useV2API: true,
  });

  return {
    createControlModeTemplate,
    updateControlModeTemplate,
    deleteControlModeTemplate,
  };
};
